import script from "./UneditableGeneralBoxData.vue?vue&type=script&setup=true&lang=js"
export * from "./UneditableGeneralBoxData.vue?vue&type=script&setup=true&lang=js"

import "./UneditableGeneralBoxData.vue?vue&type=style&index=0&id=25ab0738&scoped=true&lang=css"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ab0738"]])

export default __exports__